module.exports = __webpack_public_path__ + "static/media/45.7656424e.png";